import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useWithdraws = (page = 1, term = null, status = null) => useQuery({ queryKey: ['withdraws', page, term, status], queryFn: async () => {
    const callback = await API.get(`/withdraws?page=${page}${term ? `&term=${term}` : ''}${status ? `&status=${status}` : ''}`)
    return callback?.data
}})

export default useWithdraws